import { TeamOutlined, UserOutlined } from "@ant-design/icons";
import { Grid, Spin, Tooltip, Typography } from "antd";
import { useUser } from "components/Login/hook";
import { useParams } from "react-router";
import styled from "styled-components";
import { colors } from "styles/variables";

const LoggedInUserContainer = styled.div`
  color: ${colors.neutral["70"]};
  display: block;
  padding: 16px 24px;

  .ant-typography {
    color: ${colors.neutral["70"]};
    margin: 4px;
  }
`;

const OrgText = styled(Typography.Text)`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.neutral["50"]};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;

  &:hover {
    overflow: visible;
    white-space: normal;
  }
`;

const OrgIconDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
`;

export const LoggedInUserNavItem: React.FC<{ collapsed?: boolean }> = ({
  collapsed,
}) => {
  const { user, tenant } = useUser();
  const { orgSlug } = useParams();
  const { lg } = Grid.useBreakpoint();

  if (!lg) return null;

  if (collapsed) {
    const label =
      tenant.state === "found" && tenant.isSandbox
        ? "Sandbox User"
        : (user?.displayName ?? user?.email ?? "");
    return (
      <Tooltip
        placement="right"
        title={label ? `${label}${orgSlug ? ` · ${orgSlug}` : ""}` : undefined}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "12px 0",
          }}
        >
          <UserOutlined style={{ fontSize: 18, color: colors.neutral["50"] }} />
        </div>
      </Tooltip>
    );
  }

  return (
    <LoggedInUserContainer>
      <Typography.Paragraph>Welcome,</Typography.Paragraph>
      {tenant.state === "found" && tenant.isSandbox ? (
        <Typography.Paragraph strong>Sandbox User</Typography.Paragraph>
      ) : user ? (
        <Typography.Paragraph strong>
          {user.displayName || user.email}
        </Typography.Paragraph>
      ) : (
        <Spin />
      )}
      {orgSlug && (
        <OrgIconDiv>
          <TeamOutlined
            style={{ fontSize: "14px", color: colors.neutral["40"] }}
          />
          <OrgText title={orgSlug}>{orgSlug}</OrgText>
        </OrgIconDiv>
      )}
    </LoggedInUserContainer>
  );
};
